import React from "react";
import siteConfig from "../config/siteConfig";
import "../css/delivery.scss";
import PolicySidebar from "./PolicySidebar";

export const POLICY_UPDATED = "17 October 2026";

export function PolicyContactBox({ label = "Need help?", linkLabel = "Email us" }) {
  return (
    <div className="policy-contact-box">
      <div>
        <span>{label}</span>
        <strong>{siteConfig.contact.email}</strong>
      </div>
      <a href={`mailto:${siteConfig.contact.email}`}>{linkLabel}</a>
    </div>
  );
}

export default function PolicyPage({
  activePath,
  eyebrow = "Customer information",
  title,
  intro,
  note,
  sections,
}) {
  const tableOfContents = sections.map(({ id, shortTitle, title: sectionTitle }) => ({
    id,
    label: shortTitle || sectionTitle,
  }));

  return (
    <main className={`policy-page policy-page--${activePath.replace(/^\//, "")}`}>
      <header className="policy-hero">
        <div>
          <p className="policy-eyebrow">
            {eyebrow} · {siteConfig.brandName}
          </p>
          <h1>{title}</h1>
        </div>
        <div className="policy-hero__intro">
          <p>{intro}</p>
          <span>Last updated {POLICY_UPDATED}</span>
        </div>
      </header>

      <div className="policy-shell">
        <PolicySidebar activePath={activePath} tableOfContents={tableOfContents} />
        <article className="policy-content">
          {note && (
            <div className="policy-demo-note" role="note">
              <strong>{note.title}</strong>
              <p>{note.content}</p>
            </div>
          )}
          {sections.map((section, index) => (
            <section id={section.id} key={section.id}>
              <p className="policy-section-number">
                {String(index + 1).padStart(2, "0")}
              </p>
              <h2>{section.title}</h2>
              {section.content}
            </section>
          ))}
        </article>
      </div>
    </main>
  );
}
